<script>
import GuestDocumentationMixin from '@/mixins/guestdocumentation'

import { SELLING_REGIONS } from '@/constants'

import { helpers } from '@/helpers.js'

// isMenuToggle: toggleMenu()
// isModalToggle: toggleModal()
// showCover: toggleCover()

export default {
  name: 'GuestDocumentationLuxuryGold',
  mixins: [ GuestDocumentationMixin ],
  computed: {},
  data () {
    return {
      isModalTermsAndConditionsToggle: false,
      constants: {
        SELLING_REGIONS
      }
    }
  },
  methods: {
    isInvalidContent (field = '') {
      return helpers.isInvalidContent(field)
    },
    toggleTermsAndConditionsModal () {
      this.isModalTermsAndConditionsToggle = !this.isModalTermsAndConditionsToggle
      document.body.classList.toggle('modal-open', this.isModalTermsAndConditionsToggle)
    },
    scrollMeTo (refName) {
      var element = document.getElementById(refName)
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      })
    },
    scrollMeDay (dd) {
      var element = document.getElementById(dd)
      var modal = document.getElementById('modal-fullscreen')
      modal.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth'
      })
    },
    printPage () {
      window.print()
    }
  }
}

</script>

<style lang="scss" scoped>
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
@import './print.scss';
</style>
<template>
  <div id="menu" class="body-page fp-viewing-home body" :class="{ 'modal-open': isModalToggle }">
    <!-- BEGIN OF site header Menu -->
    <header class="page-header navbar page-header-drawer menu-right logo-left topmenu-right animated slow fadeIn">

      <!-- Begin of menu icon toggler -->
      <button class="navbar-toggler site-menu-icon" id="navMenuIcon" :class="{ 'menu-visible': isMenuToggle }" @click="toggleMenu">
        <span class="menu-icon menu-icon-line" :class="{ 'menu-visible': isMenuToggle }">
          <span class="text show-menu-visible" :class="{ 'menu-visible': isMenuToggle }">Close</span>
          <span class="text hide-menu-visible" :class="{ 'menu-visible': isMenuToggle }">Menu</span>
          <span class="bars">
            <span class="bar1"></span>
            <span class="bar2"></span>
            <span class="bar3"></span>
          </span>
        </span>
      </button>

      <div class="cover-tittle">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id" class="light-logo" src="/landingpages/luxury-gold/img/logo.png" alt="Logo">
              <img v-else class="light-logo" src="/landingpages/luxury-gold/img/logo.png" alt="Logo">
            </span>
          </a>
        </div>
      </div>

      <div class="all-menu-wrapper" id="navbarMenu" :class="{ 'menu-visible': isMenuToggle }">
        <nav class="navbar-mainmenu">
          <div class="mainmenu-bg" @click="toggleMenu"></div>
          <div class="mainmenu-content">
            <ul class="navbar-nav">
              <li class="nav-item active">
                <a class="nav-link" href="#introduction" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('introduction')">Introduction  <span class="sr-only">(current)</span></a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#itinerary" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('itinerary')">Itinerary</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#hotel" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('hotel')">Hotels</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#experiences" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('experiences')">Optional Experiences</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#map" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('map')">Map</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#contact" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('contact')">Contact Us</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!-- END OF site header Menu-->

    <!-- BEGIN OF page main content -->
    <main class="page-main main-anim main-parallax scrollpage-container animated fadeIn" id="mainpage">

      <div class="page-cover scrolled">
        <!-- Cover Background -->
        <div class="cover-bg bg-img" :style="[ firstOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      firstOpporunityBackgroundImage
                    )}')`
                  } : { backgroundImage: 'url(/guestdocumentation/luxury-gold/img/bg-style-1.jpg)'}]">
        </div>
        <div class="cover-bg-mask bg-color">
        </div>
      </div>

      <div
        id="home"
        class="backgroundHome section section-home fullscreen-md main-home section-center content-black "
        data-section="home">
        <div class="section-wrapper animated delay-1s slow fadeIn">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
              <!--This is Home-->
                <div class="cover-header-description text-shadow-all animated fadeIn slow">
                  <div class="cover-slider-description">
                    <h1 class="cover-header-description-title1">
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                      <i class="fa fa-arrow-right ml-2"></i>
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}</span>
                      <span class="ml-5" v-if="Array.isArray(d.itineraries.locations_visited) == true">
                        <i class="fa fa-map-marker" ></i>
                        <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
                      </span>
                    </h1>
                    <div class="cover-header-description-title2" v-if="d && d.itineraries">
                      {{ d.itineraries.titleitinerary }}
                    </div>
                    <div class="cover-header-description-title3">
                      <!--<span v-if="d && d.properties_opportunity && d.properties_opportunity.id_opportunity_export_type">
                        <span v-if="d.properties_opportunity.id_opportunity_export_type === 2">Scheduled Groups</span>
                        <span v-if="d.properties_opportunity.id_opportunity_export_type === 18">Custom Group Quotation</span>
                      </span>-->
                      <span class="txt-uppercase" v-if="d && d.properties_opportunity && d.reference_number">
                        {{ d.reference_number }}
                      </span>
                    </div>
                    <a  @click="scrollMeTo('introduction')"><span class="icon-arrow-down"></span></a>
                  </div>
                </div>
              <!--Finish Home-->
              </div>

            </div>
          </div>

          <footer class="section-footer scrolldown">
            <a class="down" @click="scrollMeTo('introduction')">
              <span class="icon"></span>
              <span class="txt">INTRODUCTION</span>
            </a>
          </footer>
        </div>
      </div>

      <!-- Begin of grid list section -->
      <div class="section fl-porto text-shadow-all" data-section="introduction" id="introduction">
        <div class="section-wrapper with-margin">
          <div class="row">
            <div class="col-12 col-md-12 text-left ">
              <!-- title and description -->
            <div class="section-tittle padding-container">
              <div class="cover-header-description-title2 scrolled">Introduction <button class="btn btn-outline-white-gold form-success-gone mb-0 button_print" @click="printPage"><i class="fa fa-print"></i>Print</button>
              </div>
            </div>
             <div class="padding-container2">
               <!--PRINT: INTRODUCTION-->
                 <table id="print-header" class="print-only">
                    <tbody>
                       <tr>
                          <td width="60%">
                             <h1 class="title_trip_info">TRIP<br> INFORMATION</h1>
                          </td>
                          <td width="10%"></td>
                          <td class="total-value" width="30%">
                             <div id="logo" class="logo_print">
                              <img v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id" class="light-logo" src="/guestdocumentation/luxury-gold/img/logo_print.png" alt="Logo" width="270">
                              <img v-else class="light-logo" src="/guestdocumentation/luxury-gold/img/logo2_print.png" alt="Logo" width="270">
                             </div>
                          </td>
                       </tr>
                       <tr>
                          <td width="70%" v-if="d && d.itineraries">
                            <div class="border-trip-name">
                             <h4>{{ d.itineraries.titleitinerary }}</h4>
                            </div>
                          </td>
                          <td width="10%"></td>
                          <td class="trip-code-section" width="20%">
                            <div class="print_info_it">
                              <p id="trip-code-number-section" v-if="d && d.properties_opportunity && d.reference_number">CODE<strong id="trip-code">{{ d.reference_number }}</strong></p>
                              <p id="trip-date-section" v-if="d && d.itineraries">DATE<strong id="trip-code">{{ d.itineraries.fromitinerary | custom-date }}</strong></p>
                             </div>
                          </td>
                       </tr>
                    </tbody>
                 </table>
               <!--PRINT: INTRODUCTION-->
             </div>
             <div class="title-desc anim-4 letter-a padding-container" v-html="d.guest_documentation.introduction">
             </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of grid list section -->
      <div class="section text-shadow-all" data-section="itinerary" id="itinerary">
        <div class="section-wrapper with-margin">
          <div class="section-content anim padding-container">
            <div class="section-tittle">
              <div class="cover-header-description-title2 scrolled">Your Travel Itinerary</div>
              <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Your Travel Itinerary</h1></div>
              <div class="cover-header-description-title3" v-if="d && d.itineraries">
                {{ d.itineraries.titleitinerary }}
              </div>
              <div class="cover-header-description-title4">
                <i class="icon fa fa-calendar"></i>
                <span v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                <i class="fa fa-arrow-right"></i>
                <i class="icon fa fa-calendar"></i>
                <span v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}</span>
                <i v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)" class="fa fa-map-marker"></i>
                <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
              </div>
            </div>
            <!--PRINT: YOUR TRAVEL ITINERARY-->
            <ul id="days-box" class="print-only print__itinerary">
              <li :id="`day${index}`" v-for="(day, index) in d.itineraries.days" :key="index" class="print__itinerary--item">
                <h4 class="title-day-date">DAY {{ index + 1}} <span class="title-day" v-html="day.title"></span></h4>
                <p class="dl-print">
                  <span v-if="day" class="date">{{ day.startdate | custom-date }}</span> / <span class="location"
                    v-if="day && day.locations && Array.isArray(day.locations)"> <span>{{ day.locations | custom-join('name')
                      }}</span>
                  </span>
                </p>
                <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                <p v-if="day.meals">
                  <strong class="mr-1">MEAL(S):</strong>
                  <span>{{ day.meals | custom-join('mealsday') }}</span>
                </p>
                <p v-if="day.accommodation">
                  <strong class="mr-1">ACCOMMODATION:</strong>
                  <span>{{ day.accommodation}}</span>
                </p>
              </li>
            </ul>
            <!--PRINT: YOUR TRAVEL ITINERARY-->
            <div class="row row-random grid-media-aside-text fade-3 no-print">
              <!-- an item -->
              <div class="item col col-12 col-md-6 text-left" v-for="(day, index) in d.itineraries.days" :key="index">
                <div class="media-aside-text">
                  <div class="media-image">
                    <div class="media-image-content">
                    <img v-if="day.url_image_1200_725" :src="day.url_image_1200_725"/>
                    <img v-if="!day.url_image_1200_725" src="/guestdocumentation/luxury-gold/img/day-img.jpg"/>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5 class="media-day">Day {{ day.startday }}</h5>
                    <h5 class="media-title" v-html="day.title"></h5>
                      <h6 class="media-date">
                        <i class="icon fa fa-calendar color-golden mr-2"></i>
                        <span v-if="day">{{ day.startdate | custom-date }}</span>
                      </h6>
                      <h6 v-if="day && day.locations && Array.isArray(day.locations)" class="media-location mt-1">
                        <i class="icon fa fa-map-marker color-golden mr-2"></i>
                        <span >{{ day.locations | custom-join('name') }}</span>
                      </h6>
                    <h6 class="media-details" data-toggle="modal" data-target="#modal-fullscreen" @click="dayScrollTo(index)"><span class="text">DETAILS</span></h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->
     <!-- Begin of map section -->
      <div class="section section-register content-white text-shadow-all no-print" data-section="map" id="map">
        <div class="section-wrapper with-margin">
          <div class="section-content anim padding-container">
            <div class="section-tittle">
              <div class="cover-header-description-title2 scrolled no-print  map_print_title">Map</div>
              <div class="title-print print-only"><h2 class="display-5 anim-2">Map</h2></div>
            </div>
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc">
                  <p class="mb-5 mt-3">Map route is to be used as a guide for illustration purposes only, and does not represent the exact path taken.</p>
                </div>
              </div>

              <div class="col-12 col-md-12">
                <div class="section-maps">
                  <Map :locations="locationsVisited" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of description section -->
          <div class="section fullscreen-md-off" data-section="hotel" id="hotel">
            <div class="section-wrapper with-margin section-hotel">
              <div class="section-content anim padding-container">
                <div class="section-tittle">
                  <div class="cover-header-description-title2 scrolled">Hotel List</div>
                  <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Hotel List</h1></div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-12 text-left">
                    <div class="section-info white">
                      <div class="section-column">
                          <div v-html="d.guest_documentation.hotel_list">
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

      <!-- Begin of description section -->
          <div class="section fullscreen-md-off" data-section="experiences" id="experiences" v-if="!isInvalidContent(d.guest_documentation.optional_experience)">
            <div class="section-wrapper with-margin">
              <div class="section-content anim padding-container">
                <div class="section-tittle">
                  <div class="cover-header-description-title2 scrolled">Optional Experiences</div>
                  <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Optional Experiences</h1></div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-12 text-left">
                    <div class="section-info white-gold">
                      <div v-html="d.guest_documentation.optional_experience"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

      <!-- Begin of footer section -->
      <footer>
          <div class="footer-left text-shadow-all">
            <ul class="social">
            <li>
              <a  @click="scrollMeTo('home')">
                <i class="icon-arrow-up"></i>
              </a>
            </li>
              <li>
                <a @click="scrollMeTo('itinerary')">
                  <i class="icon fa fa-globe"></i>
                </a>
              </li>
              <li>
                <a @click="scrollMeTo('contact')">
                  <i class="icon fa fa-phone"></i>
                </a>
              </li>
            </ul>
          </div>
        <div class="section-wrapper padding-footer">
          <div class="powered-by-text">
            Powered by <img src="/guestdocumentation/luxury-gold/img/logo-itp.png" width="80"> All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}
          </div>
        </div>
      </footer>
    </main>

    <!-- Modal -- TERMS AND CONDITIONS -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-terms-and-conditions-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalTermsAndConditionsToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalTermsAndConditionsToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleTermsAndConditionsModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content  ">
            <div class="modal-body">
              <div class="title-desc"><h3 class="h2 color-golden pt-4 text-center">Terms & Conditions</h3></div>
              <div
                class="title-desc anim-4 padding-container scrollable "
                v-html="d.itineraries.terms_conditions">
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- Finish Modal-- TERMS AND CONDITIONS -->

    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal modal-fullscreen fade modalDays animated fadeIn"
      id="modal-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
      :class="{ 'show': isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle">
      <div class="section-header">
        <div class="label-logo">
          <img v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id" class="light-logo" src="/guestdocumentation/luxury-gold/img/logo.png" alt="Logo">
          <img v-else class="light-logo" src="/guestdocumentation/luxury-gold/img/logo.png" alt="Logo">
        </div>
        <button
          type="button" class="close" data-dismiss="modal" aria-hidden="true"
          @click="toggleModal"><i class="fa fa-times"></i></button>
      </div>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">

            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days" :key="index">
              <div class="row">
                <div class="col-md-6 cover-image">
                  <img v-if="day.url_image_1600_900" :src="day.url_image_1600_900"/>
                  <img v-if="!day.url_image_1600_900" src="/guestdocumentation/luxury-gold/img/day-img.jpg"/>
                </div>
                <div class="col-md-6 section-text">
                  <div class="align-vcenter">
                    <h1>Day {{ index + 1}}</h1>
                    <p class="subtittle" v-html="day.title"></p>
                    <p class="date">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span class="text-uppercase" v-if="day">{{ day.startdate | custom-date }}</span>
                    </p>
                    <p class="location mt-2" v-if="day && day.locations && Array.isArray(day.locations)" >
                      <i class="fa fa-map-marker mr-2"></i>
                      <span>{{ day.locations | custom-join('name') }}</span>
                    </p>
                    <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">ACCOMMODATION:</strong>
                      <span v-html="day.accommodation"></span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldownDay nextday"
                  v-if="index != Object.keys(d.itineraries.days).length - 1">
                    <a class="down" @click="scrollMeDay(`day${index+1}`)">
                      <span class="txt">DAY {{ Number(day.startday) + 1 }}</span>
                    </a>
                  </footer>
                  <footer class="section-footer scrolldownDay nextday" v-else>
                    <a class="down" @click="scrollMeDay('day0')">
                      <span class="txt">DAY 1</span>
                    </a>
                  </footer>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- Finish Modal Fullscreen -- DAYS-->
  </div>
</template>
